export enum EstadoPago {
    PENDIENTE = 'PENDIENTE',
    PAGADO = 'PAGADO',
    CANCELADO = 'CANCELADO'
}

export enum EstadoConfiguracion {
    PENDIENTE = 'PENDIENTE',
    EN_PROCESO = 'EN_PROCESO',
    CONFIGURADO = 'CONFIGURADO'
}

export enum TipoRegistroControl {
    TITULAR = 'TITULAR',
    ADJUNTA = 'ADJUNTA'
}
